import React, {useState, useEffect} from 'react';
import './Allmail.scss';
import { IoMdArrowDropdown } from "react-icons/io";
import { IoMdArrowBack } from "react-icons/io";
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FiDownload } from "react-icons/fi";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { useRef } from 'react';
import calendar from '../../../assets/Images/uit_calender.png';
import { format } from "date-fns";
import { IoIosSearch } from "react-icons/io";
import { RiDeleteBin5Line } from "react-icons/ri";
import deleteicon from '../../../assets/Images/Group 505.png';
import jsPDF from "jspdf";
import "jspdf-autotable";

function Allmail() {
  const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

const location = useLocation();

   const [selectedTab, setSelectedTab] = useState('All Mails'); 
   const [emails,setEmails] =useState([]);
   const [campaigns, setCampaigns] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showpopup, setShowPopup] = useState(false);
   const navigate = useNavigate("");
   const dropdownRef = useRef(null);
   const openRef = useRef(null);
    const wrapperRef = useRef(null);
     const [fromDate, setFromDate] = useState("");
     const [isOpen, setIsOpen] = useState(false);
     const [toDate, setToDate] = useState("");
     const [sortOption, setSortOption] = useState("Recently created");
const [statusFilter, setStatusFilter] = useState("All");
const [searchQuery, setSearchQuery] = useState("");
const [selectedEmailIds, setSelectedEmailIds] = useState([]);
const [selectedCampaignIds, setSelectedCampaignIds] = useState([]);



   useEffect(() => {
  if (location.state?.selectedTab) {
    setSelectedTab(location.state.selectedTab);
  }
}, [location.state])

  useEffect(() => {
    const fetchUserEmails = async () => {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
  
      const response = await fetch(`${baseURL}/api/individual-emails/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      const data = await response.json();
  
      if (response.ok) {
        const sortedEmails = (data.emails || []).sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );
  setEmails(sortedEmails);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong!',
          confirmButtonColor: 'red',
        });
      }
    };
  
    fetchUserEmails();
  }, []);

  useEffect(() => {
  const fetchCampaigns = async () => {
    const token = localStorage.getItem('token')
    try {
      const response = await fetch(`${baseURL}/api/create-campaign`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch campaigns");
      }

     const sortedCampaigns = result.sort(
  (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
);
setCampaigns(sortedCampaigns);
    } catch (err) {
      Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong!',
          confirmButtonColor: 'red',
        });
    }
  };

  fetchCampaigns();
}, []);


  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const filteredEmails = statusFilter === "All"
  ? emails
  : emails.filter(row => row.status === statusFilter);


const filteredCampaigns = statusFilter === "All"
  ? campaigns
  : campaigns.filter(campaign => 
      (campaign.status || campaign.sentStatus) === statusFilter
    );

  const dateFilteredEmails = filteredEmails.filter(row => {
  const createdAt = new Date(row.createdAt).getTime();
  const from = fromDate ? new Date(fromDate).getTime() : null;
  const to = toDate ? new Date(toDate).getTime() : null;

  if (from && to) return createdAt >= from && createdAt <= to;
  if (from) return createdAt >= from;
  if (to) return createdAt <= to;
  return true; // no range selected, keep all
});

const dateFilteredCampaigns = filteredCampaigns.filter(campaign => {
  const createdAt = new Date(campaign.createdAt).getTime();
  const from = fromDate ? new Date(fromDate).getTime() : null;
  const to = toDate ? new Date(toDate).getTime() : null;

  if (from && to) return createdAt >= from && createdAt <= to;
  if (from) return createdAt >= from;
  if (to) return createdAt <= to;
  return true;
});

const searchFilteredCampaigns = dateFilteredCampaigns.filter(campaign =>
  campaign.campaignName.toLowerCase().includes(searchQuery.toLowerCase())
);

const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;

const currentRows = dateFilteredEmails.slice(indexOfFirstRow, indexOfLastRow);
const currentCampaigns = searchFilteredCampaigns.slice(indexOfFirstRow, indexOfLastRow);

const totalPages = Math.ceil(dateFilteredEmails.length / rowsPerPage);
const totalCampaignPages = Math.ceil(searchFilteredCampaigns.length / rowsPerPage);

const nextPage = () => {
  const totalPagesToCheck = selectedTab === 'All Mails' ? totalPages : totalCampaignPages;
  if (currentPage < totalPagesToCheck) {
    setCurrentPage(currentPage + 1);
  }
};

const prevPage = () => {
  if (currentPage > 1) setCurrentPage(currentPage - 1);
};




   const toggleDropdown = () => {
      setShowDropdown(!showDropdown);
    };
  
    
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShowDropdown(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const toggle = () => {
      setShowPopup(!showpopup)
    }

     useEffect(() => {
      const handleClickOutside = (event) => {
        if (openRef.current && !openRef.current.contains(event.target)) {
          setShowPopup(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

     useEffect(() => {
        function handleClickOutside(event) {
          if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        }
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

      const togglePicker = () => setIsOpen(!isOpen);

       const formatDate = (date) =>
          date ? format(new Date(date), "dd MMM yyyy") : "";

       const handleExportData = () => {
  const doc = new jsPDF();

  if (selectedTab === "All Mails") {
    if (emails.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Data",
        text: "No emails to export!",
      });
      return;
    }

    doc.text("All Mails", 14, 15);

    const columns = ["Email ID", "Subject", "Status", "Set Time & Date"];

    const rows = emails.map((row) => {
      const date = new Date(row.createdAt);
      const options = { month: "short", day: "numeric" };
      const formattedDate = date.toLocaleDateString("en-US", options);
      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      return [
        row.recipientEmail,
        row.subject,
        row.status,
        `${formattedDate} ${formattedTime}`,
      ];
    });

    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 25,
    });

    doc.save("emails.pdf");

  } else if (selectedTab === "All Campaign") {
    if (campaigns.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Data",
        text: "No campaigns to export!",
      });
      return;
    }

    doc.text("All Campaigns", 14, 15);

    const columns = ["Campaign Name", "Total Emails", "Status", "Set Time & Date"];

    const rows = campaigns.map((campaign) => {
      const formattedDate = campaign.createdAt
        ? new Date(campaign.createdAt).toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          })
        : "N/A";

      return [
        campaign.campaignName,
        campaign.totalRecipients || 0,
        campaign.status || "Pending",
        formattedDate,
      ];
    });

    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 25,
    });

    doc.save("campaigns.pdf");

  } else {
    Swal.fire({
      icon: "info",
      title: "No Tab Selected",
      text: "Please select a tab to export data.",
    });
  }
};

const handleSort = (option) => {
  setSortOption(option);
  setShowDropdown(false); 

  if (selectedTab === "All Mails") {
    let sortedEmails = [...emails];
    if (option === "Recently created") {
      sortedEmails.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } if (option === "Last Modified") {
  sortedEmails.sort((a, b) => {
    const updatedA = a.updatedAt ? new Date(a.updatedAt) : new Date(a.createdAt);
    const updatedB = b.updatedAt ? new Date(b.updatedAt) : new Date(b.createdAt);
    return updatedB - updatedA; 
  });
}
 else if (option === "Ascending Order") {
      sortedEmails.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    } else if (option === "Descending Order") {
      sortedEmails.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
    setEmails(sortedEmails);
  }

  if (selectedTab === "All Campaign") {
    let sortedCampaigns = [...campaigns];
    if (option === "Recently created") {
      sortedCampaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (sortOption === "Last Modified") {
  sortedCampaigns.sort((a, b) => {
    // Use updatedAt if exists, else fallback to createdAt
    const updatedA = a.updatedAt ? new Date(a.updatedAt) : new Date(a.createdAt);
    const updatedB = b.updatedAt ? new Date(b.updatedAt) : new Date(b.createdAt);
    return updatedB - updatedA; // DESCENDING: newest first
  });
    } else if (option === "Ascending Order") {
      sortedCampaigns.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    } else if (option === "Descending Order") {
      sortedCampaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
    setCampaigns(sortedCampaigns);
  }
};

const handleStatusFilter = (status) => {
  setStatusFilter(status);
  setShowPopup(false); 
  setCurrentPage(1);
};

const itemStyle = {
  padding: "8px 20px",
  cursor: "pointer",
  fontSize: "15px",
  fontWeight: "500",
};

const handleDelete = async () => {
  const token = localStorage.getItem("token");

  if (selectedTab === "All Mails") {
    if (selectedEmailIds.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Selection",
        text: "Please select at least one email to delete.",
      });
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/individual-emails/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ids: selectedEmailIds }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to delete emails.");
      }

      // Remove from UI:
      setEmails(prev => prev.filter(email => !selectedEmailIds.includes(email.emailId)));
      setSelectedEmailIds([]);

      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Selected emails deleted successfully.",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong.",
      });
    }
  } else if (selectedTab === "All Campaign") {
    if (selectedCampaignIds.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Selection",
        text: "Please select at least one campaign to delete.",
      });
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/create-campaign/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ids: selectedCampaignIds }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to delete campaigns.");
      }

      // Remove from UI:
      setCampaigns(prev => prev.filter(c => !selectedCampaignIds.includes(c.campaignId)));
      setSelectedCampaignIds([]);

      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Selected campaigns deleted successfully.",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong.",
      });
    }
  } else {
    Swal.fire({
      icon: "info",
      title: "Nothing selected",
      text: "Please select emails or campaigns to delete.",
    });
  }
};

const handleOpenIndividualDraft = (individualDraftId) => {
  navigate(`/campaign/${individualDraftId}`, {
    state: {
      fromDraft: true,  
      individualDraftId: individualDraftId,
    }
  });
};

  
  return (
    <div className='email-form-container'>
      <div style={{display:"flex", flexDirection:"row",justifyContent:"space-between"}}>
        <div style={{display:"flex", flexDirection:"row"}}>
       <IoMdArrowBack
                style={{ fontSize: "25px", cursor: "pointer" }}
                onClick={() => navigate("/mail")}
              /> <div className="all-mails" style={{fontSize:"20px"}}>Campaigns</div>
          </div>
          <div style={{fontSize:"15px", fontweight:"500", display:"flex", flexDirection:"row", gap:"20px"}}>
          <div style={{cursor:"pointer"}} onClick={handleExportData}><FiDownload /> Export Data</div> 
         <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
  <div style={{ cursor: "pointer" }} onClick={toggleDropdown}>
   Sort by: {sortOption} {showDropdown ? <FaAngleUp /> : <FaAngleDown />}
  </div>

  {showDropdown && (
    <div
      className="dropdown-menu"
      style={{
        position: "absolute",
        top: "25px",
        right: "0",
        background: "#fff",
        width: "180px",
        border: "1px solid #ddd",
        borderRadius: "4px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        zIndex: "1000",
      }}
    >
      <div style={{ margin: 0, padding: "10px 0", textAlign:"left" }}>
        <div style={{ padding: "8px 20px", cursor: "pointer", fontSize: "15px", fontWeight: "500" }} onClick={() => handleSort("Recently created")}>
          Recently created
        </div>
        <div
          style={{ padding: "8px 20px", cursor: "pointer", fontSize: "15px", fontWeight: "500" }}
          onClick={() => handleSort("Last Modified")}
        >
          Last Modified
        </div>
        <div
          style={{ padding: "8px 20px", cursor: "pointer", fontSize: "15px", fontWeight: "500" }}
         onClick={() => handleSort("Ascending Order")}
        >
          Ascending Order
        </div>
         <div
          style={{ padding: "8px 20px", cursor: "pointer", fontSize: "15px", fontWeight: "500" }}
          onClick={() => handleSort("Descending Order")}
        >
          Descending Order
        </div>
      </div>
    </div>
  )}
</div>

          </div>
      </div>
       
      <div style={{display:"flex", flexDirection:"row", marginTop:"30px", borderBottom:"0.6px solid rgba(0, 0, 0, 0.25)", paddingBottom:"12px"}}>
       <div   className={`all-mails ${selectedTab === 'All Mails' ? 'active' : ''}`}
          onClick={() => setSelectedTab('All Mails')}>Individual Mails</div>
        <div className={`all-campaign ${selectedTab === 'All Campaign' ? 'active' : ''}`}
          onClick={() => setSelectedTab('All Campaign')}>All Campaign</div>
      </div>
      <div style={{display:"flex", flexDirection:"row", gap:"40px", justifyContent:"space-between",marginTop:"15px"}}>
      <div style={{display:"flex", flexDirection:"row", gap:"40px", alignItems:"center",marginTop:"15px"}}>
      <div>
      <div ref={openRef} style={{ position: "relative", display: "inline-block" }}>
  <div
    onClick={toggle}
    style={{
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: "500",
      marginLeft: "20px",
    }}
  >
    Status : {statusFilter} <FaAngleDown />
  </div>

  {showpopup && (
    <div
      className="dropdown-menu"
      style={{
        position: "absolute",
        top: "25px",
        right: "0",
        background: "#fff",
        width: "144px",
        border: "1px solid #ddd",
        borderRadius: "4px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        zIndex: "1000",
      }}
    >
      <div style={{ margin: 0, padding: "10px 0", textAlign: "left" }}>
        <div
          style={itemStyle}
          onClick={() => handleStatusFilter("All")}
        >
          All
        </div>
        <div
          style={itemStyle}
          onClick={() => handleStatusFilter("sent")}
        >
          Sent
        </div>
         <div
          style={itemStyle}
          onClick={() => handleStatusFilter("bounced")}
        >
          Bounced
        </div>
        <div
          style={itemStyle}
          onClick={() => handleStatusFilter("scheduled")}
        >
          Scheduled
        </div>
        <div
          style={itemStyle}
          onClick={() => handleStatusFilter("ongoing")}
        >
          Ongoing
        </div>
        <div
          style={itemStyle}
          onClick={() => handleStatusFilter("draft")}
        >
          Draft
        </div>
      </div>
    </div>
  )}
</div>


      </div>
      <div className='date-pick' ref={wrapperRef}  style={{ position: "relative", display: "inline-block", marginLeft:"20px",  }}>
          <button className='pick-date' onClick={togglePicker} >
            <span role="img" aria-label="calendar">
              <img src={calendar} alt="calendar" width="20px" style={{ paddingTop: "2px",  background:"transparent"}} />
            </span>
            {fromDate && toDate ? `${formatDate(fromDate)} - ${formatDate(toDate)}` : "Select a date range"}
          </button>
       {isOpen && (
      <div
        className="date-popup"
        style={{
          position: "absolute",
          top: "120%", 
          left: 0,
          marginRight:"60px",
          background: "white",
          border: "1px solid #ccc",
          padding: "16px",
          borderRadius: "4px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          zIndex: 9999,
        }}
        
      >
        <label
          htmlFor="fromDate"
          style={{ display: "block", marginBottom: "4px", fontWeight: "600" }}
        >
          Pick From Date (GMT):
        </label>
        <input
          id="fromDate"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          max={toDate || ""}
          style={{
            padding: "8px",
            fontSize: "14px",
            width: "200px",
            marginBottom: "12px",
            boxSizing: "border-box",
          }}
        />
        <label
          htmlFor="toDate"
          style={{ display: "block", marginBottom: "4px", fontWeight: "600" }}
        >
          Pick To Date (GMT):
        </label>
        <input
          id="toDate"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          min={fromDate || ""}
          style={{
            padding: "8px",
            fontSize: "14px",
            width: "200px",
            boxSizing: "border-box",
          }}
        />
      </div>
    )}
        </div>
        { selectedTab === "All Campaign" && (
      <div style={{ display: "flex", alignItems: "center", fontSize: "20px" }}>
        <IoIosSearch style={{ marginRight: "8px", cursor:"pointer" }}/> 
        <input
    type="text"
    placeholder="Search campaigns ....."
    value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      border: "none",
      outline: "none",
      fontSize:"15px"
    }}
  />
      </div> )}
      </div>
      <div style={{  background:"transparent", borderRadius:"5px", padding:"7px", cursor:"pointer"}}  onClick={handleDelete}>
        <img src={deleteicon} alt="delete" width="27px" />
      </div>
      </div>
    {selectedTab === 'All Mails' && (
        <div className="campaign-tablepagination">
          <table className="campaign-table">
            <thead>
              <tr>
                <th><input type="checkbox" 
                checked={selectedEmailIds.length === currentRows.length && currentRows.length > 0}
        onChange={(e) => {
          if (e.target.checked) {
           setSelectedEmailIds(currentRows.map(row => row.emailId));
          } else {
            setSelectedEmailIds([]);
          }
        }} /></th>
                <th>Email id</th>
                <th>Subject</th>
                  <th>Status</th>
                <th>Set Time & Date</th>
              </tr>
            </thead>
            <tbody>
               {currentRows.map((row, index) => {
   const date = new Date(row.createdAt); 
  const options = { month: 'short', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options);
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <tr key={index} onClick={() => {
    if (row.status === "draft") {
      handleOpenIndividualDraft(row.emailId);
    }
  }}>
      <td><input type="checkbox"
     checked={selectedEmailIds.includes(row.emailId)}
  onChange={(e) => {
    if (e.target.checked) {
      setSelectedEmailIds(prev => [...prev, row.emailId]);
    } else {
      setSelectedEmailIds(prev => prev.filter(id => id !== row.emailId));
    }
  }}
      /></td>
      <td>{row.recipientEmail}</td>
      <td>{row.subject || "No Subject"}</td>
      <td>{row.status}</td>
      <td>{`${formattedDate} ${formattedTime}`}</td>
    </tr>
  );
})}
            </tbody>
          </table>
          <div style={{ marginTop: "20px" }} className='table-pagination'>
            <button onClick={prevPage} disabled={currentPage === 1} className="nav-button">
              Prev
            </button>
            <span>
  Page {currentPage} of {selectedTab === 'All Mails' ? totalPages : totalCampaignPages}
</span>
            <button onClick={nextPage} disabled={currentPage === totalPages} className="nav-button">
              Next
            </button>
          </div>
        </div>
      )}
{selectedTab === 'All Campaign' && (
       <div className="campaign-tablepagination">
          <table className="campaign-table">
  <thead>
    <tr>
      <th><input type="checkbox"  
      checked={selectedCampaignIds.length === currentCampaigns.length && currentCampaigns.length > 0}
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedCampaignIds(currentCampaigns.map(c => c.campaignId));
          } else {
            setSelectedCampaignIds([]);
          }
        }}
      /></th>
      <th>Campaign Name</th>
      <th>Total Emails</th>
      <th>Status</th>
      <th>Set Time & Date</th>
    </tr>
  </thead>
  <tbody>
    {currentCampaigns.length > 0 ? (
      currentCampaigns.map((campaign, index) => {
         const isDraft = campaign.status === 'draft';
         return(
        <tr key={index} onClick={() => {
            if (isDraft) {
              navigate('/campaign', {
                state: {
                  type: 'campaign',
                     fromCampaignDraft: true,
                  draft: campaign
                },
              });
            }
          }}>
          <td><input type="checkbox"
         checked={selectedCampaignIds.includes(campaign.campaignId)}
  onChange={(e) => {
    const id = campaign.campaignId;
    if (e.target.checked) {
      setSelectedCampaignIds(prev => [...prev, id]);
    } else {
      setSelectedCampaignIds(prev => prev.filter(i => i !== id));
    }
  }}
          /></td>
          <td onClick={() => navigate(`/analysis/${campaign.campaignId}`)}>{campaign.campaignName}</td>
          <td>{campaign.totalRecipients || 0}</td>
          <td>{campaign.status || "Pending"}</td>
          <td>
            {campaign.createdAt
          ? new Date(campaign.createdAt).toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })
          : "N/A"}
          </td>
        </tr> )
})
    ) : (
      <tr>
        <td colSpan="5">No campaigns found.</td>
      </tr>
    )}
  </tbody>
</table>

          <div style={{ marginTop: "20px" }} className='table-pagination'>
            <button onClick={prevPage} disabled={currentPage === 1} className="nav-button">
              Prev
            </button>
            <span style={{ margin: "0 10px" }}>
              Page {currentPage} of {totalCampaignPages}
            </span>
            <button onClick={nextPage} disabled={currentPage === totalCampaignPages} className="nav-button">
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Allmail
